import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from '@nuxtjs/composition-api';
import { YouTubePlayer } from 'vue-youtube-embed';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductVideo',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const videoId = computed(() => {
  if (!props.data.link) return undefined;

  const url = new URL(props.data.link);
  const isYTBrowserLink = url.pathname === '/watch';
  return isYTBrowserLink
    ? url.searchParams.get('v')
    : url.pathname.replace('/', '');
});
const player = ref();
const isVideoShowed = ref(false);
const handleReady = (event: Event) => {
  player.value = event.target;
  player.value.playVideo();
};

return { __sfc: true,props, videoId, player, isVideoShowed, handleReady, YouTubePlayer }
}

})